export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#FAFAFA] border-t border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 bg-[#DFFF00] inline-block" />
              <span className="font-display text-lg font-semibold tracking-tight">
                THE BALL BOSS
              </span>
            </div>
            <p className="mt-4 text-[14px] text-[#525252] max-w-sm leading-relaxed">
              Tailored to you. 3D printed pickleball accessories for facilities
              across the United States.
            </p>
          </div>

          <FooterCol
            title="Catalog"
            links={[
              { label: "The Ballboy", href: "#products" },
              { label: "The Marker (Court Numbers)", href: "#products" },
              { label: "Custom Requests", href: "#quote" },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { label: "Our Process", href: "#process" },
              { label: "Case Studies", href: "#case-studies" },
              { label: "Volume Pricing", href: "#pricing" },
            ]}
          />
          <FooterCol
            title="Contact"
            links={[
              { label: "johnleecd@gmail.com", href: "mailto:johnleecd@gmail.com" },
              { label: "Request a Quote", href: "#quote" },
            ]}
          />
        </div>

        <div className="mt-14 pt-6 border-t border-[#E5E5E5] flex flex-wrap items-center justify-between gap-3 font-mono-bb text-[11px] tracking-widest text-[#525252]">
          <span>© {new Date().getFullYear()} THE BALL BOSS · ALL RIGHTS RESERVED</span>
          <span>MADE IN THE USA · v1.0</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="overline text-[#525252]">{title}</div>
      <ul className="mt-4 space-y-2.5">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              onClick={(e) => {
                if (l.href.startsWith("#")) {
                  e.preventDefault();
                  document
                    .querySelector(l.href)
                    ?.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="text-[14px] text-[#0A0A0A] hover:text-[#0055FF] transition-colors"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
